const LISTE_DEMANDE = {
  titleDemandeAff: 'Liste demandes affichages',
  titleDemandeManuel: 'Liste demandes manuelles',
  demandesAffichages: 'Demandes d\'affichages',
  demandesLogistiques: 'Demandes manuelles',
  validationDemande: {
    demadeAlreadyInGeneration: 'Il y a actuellement une génération en cours',
  },
  actions: {
    search: 'Rechercher',
    traitement: 'Lancer un traitement automatique',
    affecter: 'Affecter',
    generer: 'Générer',
    generationAuto: 'Génération en arrière plan',
    genererSansEcraser: 'Générer sans écraser les affectations',
    restrictions: 'Restrictions',
    affectationFaceBailleurMairie: 'Laisser en place bailleurs / mairies',
    faceDispo: 'Faces disponibles',
    traiteDemande: 'Passer la demande à traité',
    newDemande: 'Passer la demande à nouveau',
    verrouillerDemande: 'Verrouiller la demande',
    deverrouillerDemande: 'Déverrouiller la demande',
    nePasAfficherLc: 'Cacher les affectations LC',
    delete: 'Supprimer',
  },
  faces: {
    vendues: 'Faces vendues',
    affectees: 'Faces affectées',
    aAffecter: 'Faces à affecter',
  },
  popUpPreventionGeneration: {
    titlePopUp: 'Etes-vous sûr de vouloir générer l\'affectation automatique des faces ?',
    generer: 'Générer',
    enTacheFond: 'Générer en tâche de fond',
    checkEcrasement: 'Sans écraser les affectations déjà effectuées',
    checkEcrasementInstruction: 'Sans écraser les instructions de pose déjà effectuées',
  },
  popUpPreventionGenerationAuto: {
    titlePopUp: 'Voulez-vous lancer la génération en arrière plan ?',
    secondTitle: 'Vous serez alerté par mail à la fin de la génération sur cette adresse : {mail}',
    secondTitleNoMail: 'Vous ne serez pas notifié par mail à la fin du traitement car vous n\'avez pas d\'adresse mail renseignée.',
    generer: 'Générer',
    checkEcrasement: 'Sans écraser les affectations déjà effectuées',
    checkEcrasementInstruction: 'Sans écraser les instructions de pose déjà effectuées',
  },
  tab: {
    numCommande: 'N° commande',
    commercial: 'Commercial',
    annonceur: 'Annonceur',
    theme: 'Thème',
    produit: 'Produit',
    ville: 'Ville',
    dateDebutAffichage: 'Début d\'affichage',
    dateFinAffichage: 'Fin d\'affichage',
    semaine: 'Semaine',
    jourDepart: 'Jour départ',
    nbFacesVendues: 'Nb faces vendues',
    nbFacesDemandees: 'Nb faces demandées',
    nbFacesAffecter: 'Nb faces affect.',
    actionLogistique: 'Action',
    datePlanification: 'Réaliser pour',
    nature: 'Nature',
    etat: 'Etat',
    etatList: {
      auto: 'Auto',
      aTraiter: 'A traiter',
      traite: 'Traité',
    },
    echec: {
      title: 'Impossible de déterminer l\'affectation automatiquement',
      venduDifferentFacesAffectables: 'Cette ligne de commande vend {nFacesVendues} face(s) alors que le réseau {reseau} en contient {nFacesAffectables} encore affectables.',
      demandeLogistiqueMulti: 'Plusieurs demandes logistiques ont été planifiées à la même semaine pour le même produit',
      demandeWithDisplay: 'Un affichage est planifié à la même semaine qu\'une demande logistique manuelle',
      demandeWithPartial: 'La vente est partielle sans sélection de faces, l\'affectation automatique des demandes manuelles ne prend pas en compte ce cas',
      letInPlace: 'La face {face} a déjà une action logistique à cette date',
      letInPlaces: 'Les faces {faces} ont déjà une action logistique à cette date',
      plusVenduesQueReelles: 'Le réseau n\'a pas assez de faces affectées pour répondre à la demande commerciale',
      plusReellesQueVendues: 'L\'affectation automatique ne peut choisir car le réseau a plus de faces disponibles que demandées',
      nbManuel: '1 face affectée au réseau a été utilisée pour une action d\'affichage manuelle',
      nbManuels: '{nbManuels} faces affectées au réseau ont été utilisées pour une action d\'affichage manuelle',
      nbAffichee: '1 face affectée au réseau a été utilisée pour une autre action d\'affichage (pour de la LC par exemple)',
      nbAffichees: '{nbAffichees} faces affectées au réseau ont été utilisées pour une autre action d\'affichage (pour de la LC par exemple)',
      nbLaisseEnPlace: '1 face affectée au réseau a été utilisée pour un "laisser en place"',
      nbLaisseEnPlaces: '{nbLaisseEnPlaces} faces affectées au réseau ont été utilisées pour un "laisser en place"',
      plusTheorique: 'Il existe encore des faces qui auraient pu être affecté à cette demande',
    },
    actions: {
      affecter: 'Affecter',
      replanifier: 'Replanifier',
      modifier: 'Modifier',
      desaffecter: 'Désaffecter',
    },
  },
  filtre: {
    title: 'Filtre',
    sousTitle: 'Les filtres seront appliqués à la liste',
    actions: {
      reinitialiser: 'Réinitialiser',
      appliquer: 'Appliquer',
      noResult: 'Aucun résultat',
      search: 'Recherche...',
    },
    reseau: 'Réseau',
    produit: 'Produit',
    jourDepart: 'Jour de départ',
    nature: 'Nature',
  },
  week: 'S{week}',
  weekWithDate: 'S{week} : {dateDebut} - {dateFin}',
  info: {
    dateAffichageDiffDatePlanifie: 'La date de début de la ligne de vente ({dateDebut}) est différente de la date de pose planifiée ({datePlanifieeLogistiqueAffichage})',
    dateAffichageIdentiqueLogistique: 'la date de la demande logistique est la même semaine que la date d\'affichage de la vente',
  },
  replanifier: {
    title: 'Replanifier',
    datePosePlanifieeAuto: 'Date de pose planifiée',
    datePosePlanifieeLogistique: 'Date de réalisation',
    messages: {
      error: {
        ligneMustBeInCmd: 'Pour replanifier, la ligne de vente doit être dans une commande',
        ligneMustBeTypeProductUnitaire: 'Pour replanifier, la ligne de vente doit être de nature \'Face\'',
      },
      success: {
        replanification: 'Replanification faites avec succès',
      },
    },
  },
  desaffecter: {
    title: 'Etes-vous sûr de vouloir désaffecter cette face ?',
    messages: {
      error: {
        alReadyInOt: 'La face est déjà dans un ordre de travail. Il faut supprimer l\'OT avant de la modifier.',
      },
      success: {
        desaffectation: 'Désaffectation(s) faite(s) avec succès',
      },
    },
  },
  messages: {
    error: {
      inOt: 'La demande est déjà dans un OT',
      notSale: 'La demande doit être une vente',
      lineNotExist: 'La demande n\'existe pas',
      produitNotAvailable: 'Veuillez sélectionner des produits disponibles dans la séléction de faces',
    },
    warning: {
      produitWithoutEndDate: 'Impossible de sélectionner une face car le produit n\'a pas de date de fin',
    },
    success: {
      DemandeDelete: 'Demande supprimée avec succès',
      demandeMulti: 'Les demandes ont été supprimées avec succès.',
    },
  },
  popUpSuppression: {
    title: 'Etes-vous sûr de vouloir supprimer cette demande manuelle ?',
    titleMutlti: 'Êtes-vous sûr de vouloir supprimer ces demandes manuelles ?',
  },
};

export default LISTE_DEMANDE;
